import cn from 'classnames'
import PropTypes from 'prop-types'

import i18n from 'services/i18n'
import s from './ActivityIndicator.module.scss'

const ActivityIndicator = ({ blue, className }) => (
  <div
    role="status"
    aria-busy="true"
    aria-live="polite"
    aria-label={i18n.t('common.loading')}
  >
    <div className={cn(s.spinner, className)}>
      <div className={cn(s.dot1, blue && s.blue)}></div>
      <div className={cn(s.dot2, blue && s.blue)}></div>
    </div>
  </div>
)

ActivityIndicator.propTypes = {
  blue: PropTypes.bool,
  className: PropTypes.string
}

ActivityIndicator.defaultProps = {
  blue: false,
  className: null
}

export { ActivityIndicator }
